import isEmpty from 'lodash/isEmpty';
import { replace } from 'redux-first-router';

import { payloadSel, querySel } from '@location';
import { emptyObj } from '@shared/constants';
import { ROUTE_ADULT_ACTIVITY_LOGS, ROUTE_ADULT_PROFILE } from '@shared/duck';
import { setOrganization } from '@shared/duck/actions';
import { organizationPositionsSel } from '@shared/duck/selectors/general.selectors';
import { newPermissions } from '@shared/newPermissions';

import {
  AdultActivityLogsPage,
  AdultProfilePage,
  AdultProfilePagePlaceholder,
} from './components';

const routes = {
  [ROUTE_ADULT_PROFILE]: {
    path: '/adultProfile/:userId',
    Component: AdultProfilePage,
    Placeholder: AdultProfilePagePlaceholder,
    titleId: 'page.profile',
    permission: newPermissions.VIEW_ADULT_PROFILE_PAGE,
    thunk: (dispatch, getState) => {
      const state = getState();
      const positions = organizationPositionsSel(state);
      const {
        organizationGuid = '',
        adultUserId = '',
        childUserId = '',
      } = querySel(state) || emptyObj;
      const payload = payloadSel(state);

      if (
        !isEmpty(organizationGuid) &&
        !isEmpty(positions) &&
        !isEmpty(payload)
      ) {
        const { userId } = payload;
        const foundedPosition = positions.find(
          p => p.organizationGuid === organizationGuid,
        );
        replace(
          `/adultProfile/${userId}?${
            adultUserId ? `&adultUserId=${adultUserId}` : ''
          }${childUserId ? `&childUserId=${childUserId}` : ''}`,
        );
        if (foundedPosition) {
          dispatch(
            setOrganization({
              guid: foundedPosition.organizationGuid,
              programType: foundedPosition.programType,
              parentOrgGuid: foundedPosition.organizationGuid,
            }),
          );
        }
      }

      if (isEmpty(organizationGuid) && childUserId && !isEmpty(payload)) {
        const { userId } = payload;
        replace(
          `/adultProfile/${userId}?childUserId=${childUserId}${
            adultUserId ? `&adultUserId=${adultUserId}` : ''
          }`,
        );
      }
    },
  },
  [ROUTE_ADULT_ACTIVITY_LOGS]: {
    path: '/adultProfile/:userId/activityLogs/:activityType',
    Component: AdultActivityLogsPage,
    Placeholder: AdultProfilePagePlaceholder,
    titleId: 'page.youthActivityLogs',
    permission: newPermissions.VIEW_ADULT_PROFILE_PAGE,
  },
};

export default routes;
